import { createStyles } from "@mantine/core";
import background from "../images/background.webp";

const useStyles = createStyles((theme) => {
  const orange = theme.colors?.orange || ["#faf6ed", "#dcc270", "#b8960c"];
  return {
    root: {
      position: "relative",
      overflow: "hidden",
    },
    kenBurns: {
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      objectFit: "cover",
      objectPosition: "center",
      animation: "kenBurns 18s ease-in-out infinite alternate",
      willChange: "transform",
    },
    overlay: {
      position: "absolute",
      inset: 0,
      background: `linear-gradient(105deg, rgba(20,18,16,0.72) 0%, rgba(20,18,16,0.45) 45%, rgba(20,18,16,0.12) 70%, transparent 85%)`,
      [theme.fn.smallerThan("md")]: {
        background: `linear-gradient(to bottom, rgba(20,18,16,0.65), rgba(20,18,16,0.5))`,
      },
    },
    orb1: {
      position: "absolute",
      width: "min(80vw, 520px)",
      height: "min(80vw, 520px)",
      top: "10%",
      right: "-10%",
      borderRadius: "50%",
      background: `radial-gradient(circle, ${orange[2]}22 0%, transparent 70%)`,
      filter: "blur(48px)",
      animation: "float1 12s ease-in-out infinite",
    },
    orb2: {
      position: "absolute",
      width: "min(60vw, 380px)",
      height: "min(60vw, 380px)",
      bottom: "15%",
      left: "-5%",
      borderRadius: "50%",
      background: `radial-gradient(circle, ${orange[1]}28 0%, transparent 70%)`,
      filter: "blur(40px)",
      animation: "float2 14s ease-in-out infinite 1.5s",
    },
    orb3: {
      position: "absolute",
      width: "min(45vw, 280px)",
      height: "min(45vw, 280px)",
      top: "45%",
      right: "15%",
      borderRadius: "50%",
      background: `radial-gradient(circle, ${orange[0]}35 0%, transparent 65%)`,
      filter: "blur(36px)",
      animation: "float3 10s ease-in-out infinite 0.8s",
    },
    grain: {
      position: "absolute",
      inset: 0,
      opacity: 0.035,
      backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E")`,
      pointerEvents: "none",
    },
  };
});

const keyframes = `
  @keyframes kenBurns {
    0% { transform: scale(1) translate(0, 0) rotate(0deg); }
    100% { transform: scale(1.12) translate(-1.5%, -1%) rotate(0.3deg); }
  }
  @keyframes float1 {
    0%, 100% { transform: translate(0, 0) scale(1); }
    33% { transform: translate(2%, -1.5%) scale(1.05); }
    66% { transform: translate(-1%, 2%) scale(0.98); }
  }
  @keyframes float2 {
    0%, 100% { transform: translate(0, 0) scale(1); }
    33% { transform: translate(-2%, 1%) scale(1.03); }
    66% { transform: translate(1.5%, -2%) scale(0.97); }
  }
  @keyframes float3 {
    0%, 100% { transform: translate(0, 0) scale(1); }
    50% { transform: translate(-1%, -1.5%) scale(1.04); }
  }
`;

export function AnimatedBackground({ children }) {
  const { classes } = useStyles();
  return (
    <>
      <style>{keyframes}</style>
      <div className={classes.root}>
        <img
          className={classes.kenBurns}
          src={background}
          alt=""
          width={1600}
          height={884}
          fetchPriority="high"
          decoding="async"
          aria-hidden
        />
        <div className={classes.orb1} aria-hidden />
        <div className={classes.orb2} aria-hidden />
        <div className={classes.orb3} aria-hidden />
        <div className={classes.overlay} />
        <div className={classes.grain} aria-hidden />
        {children}
      </div>
    </>
  );
}
